import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useEffect, useState, type FC } from 'react';
import { cx } from '../cx';

dayjs.extend(duration);

const formatTime = (time: number) => {
  const duration = dayjs.duration(time);
  const minutes = String(duration.minutes()).padStart(2, '0');
  const seconds = String(duration.seconds()).padStart(2, '0');
  const milliseconds = String(Math.floor(duration.milliseconds() / 10)).padStart(2, '0');
  return `${minutes}:${seconds}.${milliseconds}`;
};

interface Props {
  timestamp: number;
  img: string;
  imgClassName?: string;
  onClick?: () => void;
}
export const CouponCountDown: FC<Props> = (props) => {
  const { timestamp, img, imgClassName, onClick } = props;
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [isFinished, setIsFinished] = useState(true);

  useEffect(() => {
    if (!timestamp) return;

    const interval = setInterval(() => {
      const remaining = dayjs(timestamp).diff(dayjs());
      setTimeLeft(remaining);

      if (remaining <= 0) {
        setIsFinished(true);
        clearInterval(interval);
      } else {
        setIsFinished(false);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [timestamp]);

  if (!timestamp || isFinished) return null;

  return (
    <div
      className="relative animate-click text-white animate__animated animate__tada"
      onClick={onClick}
    >
      <img className="w-14" src={img} alt="coupon" />
      <div
        className={cx(
          'absolute bottom-[7px] left-0 w-full text-center text-t4-bold font-black scale-[0.8]',
          imgClassName
        )}
      >
        {formatTime(timeLeft)}
      </div>
    </div>
  );
};
